import { render } from "./LoginRegistrationLink.vue?vue&type=template&id=98ee4040&scoped=true&ts=true"
import script from "./LoginRegistrationLink.vue?vue&type=script&lang=ts"
export * from "./LoginRegistrationLink.vue?vue&type=script&lang=ts"

import "./LoginRegistrationLink.vue?vue&type=style&index=0&id=98ee4040&scoped=true&lang=css"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ee4040"]])

export default __exports__